export const POOL_TYPE_CLEANING = 0;
export const POOL_TYPE_STEP = 1;

// TODO Move into a database
export const CARTS = [
  { tagId: 20, name: 'Cart-20', color: '#999999' },
  { tagId: 30, name: 'Cart-30', color: '#80C000' },
  { tagId: 40, name: 'Cart-40', color: '#5050F0' },
  { tagId: 50, name: 'Cart-50', color: '#B05000' },
];

// TODO Move into a database
export const POOLS_GROUPS_LINE_1 = [
  [
    { id: 0, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 1, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 2, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 3, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 4, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 5, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 6, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 7, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 8, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 9, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 10, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 11, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 12, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 13, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 14, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 15, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 16, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 17, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 18, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 19, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 20, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 21, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 22, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 23, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 24, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 25, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 26, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 27, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 28, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 29, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 30, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 31, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 32, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 33, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 34, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 35, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 36, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 37, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 38, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 39, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 40, type: POOL_TYPE_CLEANING, value: 1 },
  ],
];

export const POOLS_GROUPS_LINE_2 = [
  [
    { id: 41, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 42, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 43, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 44, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 45, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 46, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 47, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 48, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 49, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 50, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 51, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 52, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 53, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 54, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 55, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 56, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 57, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 58, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 59, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 60, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 61, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 62, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 63, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 64, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 65, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 66, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 67, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 68, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 69, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 70, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 71, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 72, type: POOL_TYPE_CLEANING, value: 1 },
    { id: 73, type: POOL_TYPE_CLEANING, value: 1 },
  ],
  [
    { id: 74, type: POOL_TYPE_CLEANING, value: 1 },
  ],
];

export const findPoolById = (id, data) => {
  for (const group of data) {
    for (const item of group) {
      if (item.id === id) return item;
    }
  }
  return null;
}

export const getCartName = (tagId, carts) => {
  for (const cart of carts) {
    if (cart.tagId === tagId) return cart.name;
  }
  return null;
};

export const getCartColor = (tagId, carts) => {
  for (const cart of carts) {
    if (cart.tagId === tagId) return cart.color;
  }
  return 'black';
};

export const getFlattenPoolsList = () => {
  return [POOLS_GROUPS_LINE_1, POOLS_GROUPS_LINE_2].flat(2);
};

export const computeCartsErrors = (poolsCurrentData, poolsPreviousData, previousCartsErrors) => {
  const poolsStructure = getFlattenPoolsList();
  const cartsErrors = { ...previousCartsErrors };

  // -----------------------------
  // 1️⃣ ERREURS "TROP LENT"
  // -----------------------------
  poolsCurrentData.forEach((currentPool, poolIndex) => {
    const theoreticalPool = poolsStructure[poolIndex];

    if (currentPool && currentPool.tag_id !== null && currentPool.tag_id !== undefined) {
      const cartId = currentPool.tag_id;
      const currentValue = currentPool.value;
      const theoreticalValue = theoreticalPool?.value;

      if (typeof currentValue === "number" && typeof theoreticalValue === "number") {
        const thresholdHigh = theoreticalValue * 1.2; // 120% du théorique

        if (currentValue >= thresholdHigh) {
          if (!cartsErrors[cartId]) cartsErrors[cartId] = [];
          if (!cartsErrors[cartId].includes(poolIndex)) {
            cartsErrors[cartId].push(poolIndex);
          }
        }
      }
    }
  });

  // -----------------------------
  // 2️⃣ ERREURS "TROP RAPIDE"
  // -----------------------------
  poolsPreviousData.forEach((previousPool, poolIndex) => {
    const theoreticalPool = poolsStructure[poolIndex];

    if (previousPool && previousPool.tag_id !== null && previousPool.tag_id !== undefined) {
      const cartId = previousPool.tag_id;
      const previousValue = previousPool.value;
      const theoreticalValue = theoreticalPool?.value;

      // Vérifie si le cart a quitté ce pool (donc plus présent dans le current)
      const cartStillHere = poolsCurrentData.some(
        (currentPool) => currentPool?.tag_id === cartId
      );

      // Si le cart a quitté le pool et que sa value < 80% du théorique → trop rapide
      if (!cartStillHere && typeof previousValue === "number" && typeof theoreticalValue === "number") {
        const thresholdLow = theoreticalValue * 0.8;

        if (previousValue < thresholdLow) {
          if (!cartsErrors[cartId]) cartsErrors[cartId] = [];
          if (!cartsErrors[cartId].includes(poolIndex)) {
            cartsErrors[cartId].push(poolIndex);
          }
        }
      }
    }
  });

  return cartsErrors;
};

export const computeCartsFinished = (poolsCurrentData, poolsPreviousData, previousCartsFinished) => {
  const cartsFinished = [...previousCartsFinished];

  const previousPool = poolsPreviousData[poolsPreviousData.length - 1];

  if (previousPool && previousPool.tag_id !== null && previousPool.tag_id !== undefined) {
    const cartId = previousPool.tag_id;

    // Vérifie si le cart est encore présent quelque part dans la ligne actuelle
    const cartStillHere = poolsCurrentData.some((pool) => pool?.tag_id === cartId);

    // Si le cart a quitté le dernier pool (et donc la ligne entière)
    if (!cartStillHere)
      cartsFinished.push({...previousPool, stop_time: Math.floor(Date.now() / 1000)});
  }

  return cartsFinished;
};